export const DEFAULT_OPTS = {
    debug: true,
    timeout: 20000,
    protocol: [],
    format: 'json',
    reconnection: true,
    reconnectionAttempts: 30,
    reconnectionDelay: 1000,
    autoConnect: true,
    autoUnref: true,
    heartbeatDelay: 30000,
    multipleReceivers: true
};

export const RESERVED_EVENTS = Object.freeze({
    connect: 1,
    connect_error: 1,
    disconnect: 1,
    disconnecting: 1,
    newListener: 1,
    removeListener: 1
});
